import { useQuery } from "@tanstack/react-query";
import { STORAGE_KEYS } from "@/constants/storage";
import type { DecodedJwt } from "@/api/contracts/auth.contract";

export const USER_QUERY_KEY = ["user"];

export function decodeJwt(token: string): DecodedJwt | null {
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(
      decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join(""),
      ),
    );
  } catch {
    return null;
  }
}

export const useUser = () =>
  useQuery({
    queryKey: USER_QUERY_KEY,
    queryFn: () => {
      const token = sessionStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      if (!token) return null;
      return decodeJwt(token);
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
